<template>
    <section class="transition" :class="[{'is-active': isActive, 'is-transition-in': isTransitionIn, 'is-transition-out': isTransitionOut, 'is-translated': isTranslated}, transitionClass]">
        <div class="transition__inner">
            <h2 v-if="!isMobile" class="transition__title" :class="titleClass"> <span class="transition__title__text"> {{ title }} </span></h2>
        </div>
    </section>
</template>

<script>
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import EventHub from '@/utils/EventHub'

export default {
  name: 'app-transition',

  props: {

  },

  computed: {
      titleClass() {
          return `is-${ this.size }`
      },

      transitionClass() {
          return `is-${ this.color }`
      }
  },

  data() {
    return {
        isMobile: false,
        title: 'labor of fashion',
        size: 'small',
        color: 'black',
        isActive: false,
        isTransitionIn: false,
        isTransitionOut: false,
        isTranslated: false
    }
  },

  created()
  {
    this.addEventListeners()
  },

  mounted()
  {
      
  },

  destroyed()
  {
    this.removeEventListeners()
    clearAllBodyScrollLocks()
  },

  methods: {
      addEventListeners()
      {
        EventHub.$on('page:transition-in', this.onTransitionIn)
        EventHub.$on('page:transition-out', this.onTransitionOut)
        EventHub.$on('window:resize', this.onResize)
      },

      removeEventListeners()
      {
        EventHub.$off('page:transition-in', this.onTransitionIn)
        EventHub.$off('page:transition-out', this.onTransitionOut)
        EventHub.$off('window:resize', this.onResize)
      },

      onTransitionIn(from, to)
      {
        this.title = to.meta.title
        this.size = to.meta.size
        this.color = to.meta.color
        this.isTranslated = to.meta.translated ? true : false

        this.isTransitionIn = true
        disableBodyScroll()

        setTimeout(() => {
            this.isActive = true
            this.isTransitionIn = false
        }, 1200)
      },

      onTransitionOut()
      {
        this.isTransitionOut = true

        setTimeout(() => {
            this.isActive = false
            this.isTransitionOut = false
            enableBodyScroll()
        }, 600)
      },

    onResize(windowObj)
    {
        if(windowObj.width <= 768)
        {
            this.isMobile = true
        }
    }
  }
}
</script>

<style lang="stylus">
.transition
    z-index 99
    position fixed
    height 100vh
    width 100vw
    overflow hidden
    opacity 1
    transform translate3d(100%, 0, 0)

    &.is-black
        background-color $black

    &.is-white
        background-color $white

    &.is-active
        opacity 1
        transform translate3d(0, 0, 0)

    &.is-transition-in
        transform translate3d(0, 0, 0)
        transform-origin top left
        transition transform 1.2s $ease-in-out-circ

    &.is-transition-out
        transform translate3d(0, 0, 0)
        transform-origin top left
        opacity 0
        transition opacity 0.6s $ease-out-quad

.transition__inner
    width 100%
    height 100%
    transform translate3d(-95%, 0, 0)

    .is-active &
        transform translate3d(0, 0, 0)

    .is-transition-in &, .is-transition-out &
        transform translate3d(0, 0, 0)
        transform-origin top left
        transition transform 1.2s $ease-in-out-circ

.transition__title
    width 100%
    font-family 'Sabon'
    text-transform uppercase
    text-align center
    line-height 1
    opacity 0

    .is-active &
        opacity 1
    
    .is-transition-in &
        opacity 1
        transition opacity 0.6s $ease-in-quad 0.4s

    .is-transition-out &
        opacity 1

    .is-white &
        color $black
    
    .is-black &
        color $white

    &.is-small
        letter-spacing 0.2em
        interpolate('padding-top', 1600px, 2560px, 300px, 460px);
        interpolate('font-size', 1600px, 2560px, 120px, 172px);

        @media(max-width 1600px)
            interpolate('padding-top', 768px, 1600px, 180px, 300px);
            interpolate('font-size', 768px, 1600px, 58px, 120px);

    &.is-medium
        letter-spacing 0.05em
        interpolate('padding-top', 1600px, 2560px, 175px, 250px);
        interpolate('font-size', 1600px, 2560px, 198px, 284px);

        @media(max-width 1600px)
            interpolate('padding-top', 768px, 1600px, 122px, 175px);
            interpolate('font-size', 768px, 1600px, 99px, 198px);

    &.is-big
        // padding-top 22vh
        // font-size 420px
        letter-spacing 0.05em
        interpolate('padding-top', 768px, 2560px, 120px, 380px);
        interpolate('font-size', 768px, 2560px, 246px, 820px);

.transition__title__text
    .is-translated &
        position relative
        display block
        transform translateY(53%)

</style>